<!-- 查询结果信息展示列表：模块头+标题+时间 -->
<template>
<div class="content-block">
  <div class="search-group-title" v-if="showTitle">
    <div class="group-title">{{title}}</div>
    <div class="group-label">找到{{infoPage.total}}条结果，已显示{{showCount}}条</div>
  <router-link :to="moreLink" v-if="showMore">浏览更多</router-link>
  </div>
  <div class="info-list-content">
    <ul>
      <li v-for="info in infoPage.list">
          <component :is="infoBlock" :info="info"/></component>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
export default {
  name: 'InfoList',
  components:{},
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    moreLink: {
      type: String,
      default: '/'
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '6'
    },
    infoBlock:{
      type:Object,
      default:function(){return {}}
    },
    infoPage:{
      type:Object,
      default:function(){return {total:0,list:[]}}
    }
  },
  data() {
    return {
      showMore:true,
      //infoList:[],
    }
  },
  computed: {
    showCount: function () {
      let showCount=0;
      if(this.infoPage.total>this.infoPage.list.length){
        this.showMore=true;
        return this.infoPage.list.length;
      }else{
        this.showMore=false;
        return this.infoPage.total;
      }
    }
  },
  created:function(){
    //this.infoList=this.Global.newsListDemo.slice(0,this.count);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-group-title{
  position:relative;
  width:100%;
  height:40px;
  //border-bottom:1px solid #bbbbbb;
  text-align:left;
  margin-bottom:5px;
  background:#eee;
}

.search-group-title .group-title{
  position:relative;
  float:left;
  height:40px;
  padding:0px 15px 0px 15px;
  font-size:14px;
  font-weight:800;
  line-height:40px;
  text-align:left;
  color: #515151;
  //background:yellow;
}

.search-group-title .group-label{
  position:relative;
  float:left;
  height:40px;
  font-size:12px;
  //font-weight:400;
  line-height:40px;
  color: #888888;
  //background:green;
}

.search-group-title a{
  text-decoration: none;
  float:right;
  padding-right:10px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color: #888888;
}

.search-group-title a{
  text-decoration: none;
  float:right;
  padding-right:10px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color: #aaa;
}

.search-group-title a:after{
    content: "\00BB";
    font-size: 14px;
    color: #aaa;

}


ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoList05.vue